import { Box, Grid, Typography } from "@mui/material";
import React from "react"
import style from "./style";
import { BarChart } from "@mui/x-charts/BarChart";
import { useTheme, useMediaQuery } from "@mui/material";
import theme from "../../../../../theme/theme";

const jobApplied = [40, 30, 20, 5, 15, 25, 80,80, 80, 80, 80, 80];
const hired = [30, 20, 5, 25, 40, 30, 5];
const resigned = [0, 10, 20, 30, 40, 50, 15, 20, 20, 20, 20, 20];
const xLabels = ["Jan ", "Feb", "March", "April", "May", "June", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


const FinanicialStatement = () => {

  const materialUITheme = useTheme();
  const isDesktop = useMediaQuery(materialUITheme.breakpoints.up("md"));
  const isLargeMobile = useMediaQuery("(max-width: 768px)");
  const isSmallMobile = useMediaQuery("(max-width: 400px)");


  return (
    <>
      <Box px="15px" pt="20px" display={{xs: "block", md:"flex"}}>
        <Typography variant="h5" sx={style.leaveHeading}>Financial Statement</Typography>

      </Box>



      <Grid container spacing={2} px="15px">
        <Grid item md={12} xs={12}>
          <Box sx={style.cardGraph}>

            <BarChart
              width={isDesktop ? 1000 : (isLargeMobile ? 950 : (isSmallMobile ? 250 : "100%"))}
              height={isDesktop ? 400 : (isLargeMobile ? 550 : (isSmallMobile ? 200 : 150))}
              p={0}
              series={[
                { data: jobApplied, label: "Job Applied", id: "pvId", stack: "total", color: theme.palette.primary.main },
                { data: hired, label: "Hired", id: "hiId", stack: "total", color: theme.palette.lightGray.main },
                { data: resigned, label: "Resigned", id: "uvId", stack: "total", color: theme.palette.secondary.main },
              ]}
              sx={{
                "& .css-1b57f9y-MuiChartsAxis-root .MuiChartsAxis-tick ": {
                  stroke: "#fff",
                },
                "& .MuiChartsAxis-line": {
                  display: "none",
                },
              }}
              xAxis={[{ data: xLabels, scaleType: "band", categoryGapRatio: 0.4 }]}
            />
 
          </Box>

        </Grid>
      </Grid>

    </>
  )
}

export default FinanicialStatement;